import { UserActivity } from '@/store/modules/jig/types'

interface JigWithUserActivity {
  Id?: string
  UserActivity?: UserActivity
}

// Staging builds alias this no-op adapter to the opt-in service lock harness.
export function getJigSpaceServiceLockMock(_jigId?: string, _existingActivity?: UserActivity): UserActivity | null {
  return null
}

export function applyJigSpaceServiceLockMock<T extends JigWithUserActivity>(jig: T): T {
  return jig
}
